import { WebpTeam, WebpTeamimg } from "../assets";

import Footer from "../components/Footer";
import TeamCard from "../components/TeamCard";

export default function Teams() {
  return (
    <>
      <section className="about__hero">
        <img
          loading="lazy"
          className="about__hero__img"
          src={WebpTeam}
          alt=" At AFF, we pioneer evocative aromas and tastes that inspire and endure. As an ambitious trailblazer in Asia, we envision a world where every Scent tells a story, and every Flavor is a journey AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey ,AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey,advancedffwebsite aff  aff website   advancedff advancedff.com advancedff advancedff advancedgg advancedff
advancedgg affwebsite  Advanced Flavors & Fragrances Pte. Ltd.
Advanced Flavors & Fragrances Pte. Ltd.
Advanced Flavors and  Flavors & Fragrances Pte. Ltd.
advnacedff   flavour flavour singapore advancedff-Image Containg Buildings"
        />
        <div className="about__hero__content">
          <div className="about__hero__content__heading">Our Team</div>
        </div>
      </section>
      <div className="certification__text__section">
        Backing our R&D core is a dedicated procurement team, adept at sourcing
        top-quality raw materials from around the globe from origin sources. Our
        regulatory team complements this by proficiently navigating the
        intricate landscape of local and international food regulations to
        enable a fuss-free experience for our customers. <br /> <br />
        Serving a multitude of sectors from confectioneries, bakeries, dairies,
        to beverage manufacturers and pharmaceutical companies, our dedicated
        logistics and customer service teams underscore every interaction with
        quality, consistency, and excellence. <br /> <br />
        At Advanced Flavors & Fragrances, we are not just anticipating the
        future of flavors and fragrances - we are shaping it. We invite you to
        join us on this voyage of sensory discovery and innovation. Together,
        let's explore the limitless landscape of taste and aroma.
      </div>
      <div className="team__section__container">
        <TeamCard img={WebpTeamimg} name="Kamran Ali" designation="CEO" />
        <TeamCard img={WebpTeamimg} name="Kamran Ali" designation="CEO" />
        <TeamCard img={WebpTeamimg} name="Kamran Ali" designation="CEO" />
        <TeamCard img={WebpTeamimg} name="Kamran Ali" designation="CEO" />
        <TeamCard img={WebpTeamimg} name="Kamran Ali" designation="CEO" />
        <TeamCard img={WebpTeamimg} name="Kamran Ali" designation="CEO" />
      </div>
      <Footer />
    </>
  );
}
